import React, { useEffect, useState } from "react";
import classes from './Reportss.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import {
    BarChart2,
    Filter,
    CalendarClock,
    Mail,
    ArrowLeft,
    Printer,
    Download,
    Settings,
    Loader2
} from 'lucide-react';
import Footer from "../../Components/Footer/Footer";

const Reportss = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingReport, setLoadingReport] = useState(false);

    const handleRunReport = async (e) => {
        e.preventDefault();
        if (!startDate || !endDate) {
            alert("Please select start and end dates");
            return;
        }

        try {
            setLoading(true);
            setLoadingReport(true); // ✅ show "Loading..." on button
            const token = localStorage.getItem("authToken");
            const companyId = localStorage.getItem("company_id");

            const res = await axios.get(
                `${BASE_URL}/v1/reports/income-detailed-report`,
                {
                    params: { start_date: startDate, end_date: endDate, company_id: companyId },
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            setReportData(res.data?.data || null);
        } catch (err) {
            console.error("Error fetching report:", err);
            setReportData(null);
        } finally {
            setLoading(false);
            setLoadingReport(false); // ✅ reset button text
        }
    };
    useEffect(() => {
        const handleAfterPrint = () => {
            if (document?.documentElement?.dataset) {
                delete document.documentElement.dataset.printView;
            }
        };

        window.addEventListener("afterprint", handleAfterPrint);
        return () => window.removeEventListener("afterprint", handleAfterPrint);
    }, []);

    const handlePrinter = () => {
        document.documentElement.dataset.printView = "income-statement";
        window.print();
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                {/* Action Buttons */}
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                {/* Back Button */}
                <div className={classes.matron}>
                    <div>
                        <button
                            className={classes.backButton}
                            onClick={() => navigate(-1)}
                        >
                            <ArrowLeft size={16} style={{ marginRight: '6px' }} />
                        </button>
                    </div>

                    <div>
                        <p className={classes.toplea}>Income Statement</p>
                        <p className={classes.topl}>Financial position as of {new Date().toLocaleDateString()}</p>
                    </div>
                </div>

                <div className={classes.act}>
                    <form className={classes.form} onSubmit={handleRunReport}>
                        <div className={classes.group1}>
                            <label>Start Date:</label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                className={classes.statusDropdown}
                            />
                        </div>
                        <div className={classes.group1}>
                            <label>End Date:</label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                className={classes.statusDropdown}
                            />
                        </div>
                        <button type="submit" className={classes.greenBtn} disabled={loadingReport}>
                            <BarChart2 size={16} style={{ marginRight: "6px" }} />
                            {loadingReport ? "Loading..." : "Run Report"}
                        </button>


                    </form>

                    <div className={classes.iconbars}>
                        <div className={classes.iconbarr}>
                            <div className={classes.iconbar}>
                                <Filter size={16} style={{ marginRight: "6px" }} />
                                Filter
                            </div>
                            <div className={classes.iconbar}>
                                <CalendarClock size={16} style={{ marginRight: "6px" }} />
                                Schedule
                            </div>
                        </div>
                    </div>
                </div>

                <div className={classes.containere}>
                    <div className={classes.iconbarss}>
                        <div className={classes.iconbar}><Mail size={16} /></div>
                        <div className={classes.iconbar} onClick={handlePrinter} style={{ cursor: "pointer" }}>
                            <Printer size={16} />
                        </div>
                        <div className={classes.iconbar}><Download size={16} /></div>
                        <div className={classes.iconbar}><Settings size={16} /></div>
                    </div>

                    <header className={classes.headers}>
                        <h1 className={classes.companyName}>Promix Accounting Ltd</h1>
                        <h2 className={classes.title}>Income Statement</h2>
                        <p className={classes.period}>
                            {startDate && endDate
                                ? `For the period ${startDate} to ${endDate}`
                                : "Select a date range and run report"}
                        </p>
                        <button className={classes.unaudited}>unaudited</button>
                    </header>

                    <div className={classes.divider}></div>

                    {/* Report Data */}
                    {loading && (
                        <p style={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: 500 }}>
                            <Loader2 className={classes.spinner} size={18} />
                            Loading report...
                        </p>
                    )}


                    {!loading && reportData && (
                        <>
                            {reportData.records?.map((record, idx) => (
                                <section className={classes.section} key={idx}>
                                    <h3 className={classes.sectionTitle}>{record.description}</h3>
                                    {record.categories?.map((category, cIdx) => (
                                        <div key={cIdx}>
                                            <h4 className={classes.categoryTitle}>{category.description}</h4>
                                            {category.postings?.map((posting, pIdx) => (
                                                <div className={classes.row} key={pIdx}>
                                                    <p className={classes.label}>{posting.name}</p>
                                                    <p className={classes.amount}>
                                                        {typeof posting.amount === 'number' 
                                                            ? posting.amount.toLocaleString('en-US', { minimumFractionDigits: 2 })
                                                            : posting.amount}
                                                    </p>
                                                </div>
                                            ))}
                                            <div className={classes.categoryTotalRow}>
                                                <p className={classes.categoryLabel}>{category.description} Total</p>
                                                <p className={classes.categoryAmount}>
                                                    {typeof category.total === 'number'
                                                        ? category.total.toLocaleString('en-US', { minimumFractionDigits: 2 })
                                                        : category.total}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </section>
                            ))}

                            <div className={classes.netProfitRow}>
                                <p className={classes.netProfitLabel}>NET PROFIT / (LOSS)</p>
                                <p className={classes.netProfitAmount}>
                                    {
                                        (() => {
                                            const revenue = reportData.records?.find(r => r.description === "Revenue")?.categories?.reduce((sum, cat) => sum + (cat.total || 0), 0) || 0;
                                            const expenses = reportData.records?.find(r => r.description === "Expenses")?.categories?.reduce((sum, cat) => sum + (cat.total || 0), 0) || 0;
                                            const netProfit = revenue - expenses;
                                            return netProfit.toLocaleString('en-US', { minimumFractionDigits: 2 });
                                        })()
                                    }
                                </p>
                            </div>
                        </>
                    )}

                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Reportss;
